import React from 'react';
import { Configure } from 'react-instantsearch-dom';
import { isAfter } from 'date-fns';

// Components
import EventListItemBase from '@molecules/EventListItemRedesign';
import LoadingArea from '@molecules/LoadingArea';
import SearchContainer from '@search/SearchContainer';
import SearchHits from '@search/SearchHits';

// Functionality
import useEventsRecommendedFilters from '../../../hooks/algoliaFilters/useEventsRecommendedFilters';
import { getEventRegistrationURL } from '@general/entities/event';
import { checkForRegistrationCutoff } from '@general/helpers/event.helpers';
import { SAVED_EVENTS_QUERY } from '@general/graphql/event.graph';
import { mapSearchEventToProps } from '@general/transforms/event.transform';

const EventListItem = props => {
    const itemAttrs = {
        bottomLink: {
            text: 'Register For This Event',
            function: ({ code, url }) => {
                if (!url && code) {
                    window.location.href = getEventRegistrationURL(code);
                } else {
                    window.location.href = url;
                }
            },
        },
        showBottomLinkCheck: eventProps => !checkForRegistrationCutoff(eventProps),
    };

    return <EventListItemBase {...props} {...itemAttrs} />;
};

const SearchEventsRecommended = () => {
    const { filters } = useEventsRecommendedFilters();

    if (filters.length === 0) {
        return <LoadingArea />;
    }

    return (
        <SearchContainer index="events_meeting_start_time_asc">
            <Configure clickAnalytics filters={filters} hitsPerPage={3} />
            <SearchHits
                HitComponent={EventListItem}
                favoritesProp="viewerEvents"
                favoritesQuery={SAVED_EVENTS_QUERY}
                index="events_meeting_start_time_asc"
                resultsPerRow={1}
                searchType="events"
                shouldLogConversions={false}
                transformFunc={mapSearchEventToProps}
            />
        </SearchContainer>
    );
};

export default SearchEventsRecommended;
